import { useState } from 'react';

const useFilingFormDefinitions = () => {
  /**
   * @description defines the forms available on each type of filing
   * @TODO: This will need to be updated for more fine tuned control rather than just using categories where
   * some filings may not have all the same forms available
   *
   * (e.g. Emergency will have emergency regulation form in place of the "Regulation" from
   * but is currently defined by the "Rule" type below)
   */

  // #region filing menu items
  /**
   *  @description this determins which filing forms appear on which selected type
   *  @example
   *  {
      type: 'Non Rulemaking Record',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        { text: 'Emergency Regulation' },
        { text: 'Hearing Notice' },
        { text: 'Certificate of Adoption' },
        { text: 'Explanatory Statement' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'History' },
      ],
    },
   */
  let filingMenuItems = [
    {
      type: 'Non Rulemaking Record',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Rulemaking Record',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Notice Of Cancelled Hearing Or Comment Period',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Notice Of Continued Hearing Or Comment Period',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Notice Of Errors In Published Documents',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Notice Of Rulemaking Intent',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Notice Of Withdrawn Rules',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Statement Of Submission To Governor And Legislature',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Emergency Rule Document',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
    {
      type: 'Permanent Rule Document',
      menuItems: [
        { text: 'Status' },
        { text: 'Regulation' },
        // { text: 'Emergency Regulation' },
        { text: 'Agency Information'},
        { text: 'Accessibility Provisions'},
        { text: 'Hearing Notice' },
        { text: 'Fiscal Impact Statement' },
        { text: 'Explanatory Statement' },
        { text: 'Affidavit of Publication' },
        { text: 'Certificate of Adoption' },
        { text: 'History' },
        { text: 'Notes' },
        { text: 'Files' },
      ],
    },
  ];
  // #endregion

  // #region form definitions
  /**
   * @description array of json data defining each forms structure rendered in FilingForm.tsx
   */
  let filingFormDefinitions = [
    {
      type: 'Regulation',
      formDef: [
        { name: 'filingName', type: 'textfield', label: 'Filing Name', required: true },
        { name: 'agencySelect', type: 'dropdown', label: 'Agency', required: true },
        { name: 'titleSelect', type: 'dropdown', label: 'Title', required: true },
        // { name: 'chapterSelect', type: 'dropdown', label: 'Chapter', required: true },
        { name: 'workflowSelect', type: 'dropdown', label: 'Workflow', required: true },
        { name: 'draftSelect', type: 'multiselect', textfield: 'draftName', label: 'Draft',
          required: true, disabled: true,},
      ],
    },
    {
      type: 'Emergency Regulation',
      formDef: [
        { name: 'filingName', type: 'textfield', label: 'Filing Name', required: true },
        { name: 'agencySelect', type: 'dropdown', label: 'Agency', required: true },
        { name: 'titleSelect', type: 'dropdown', label: 'Title', required: true },
        { name: 'workflowSelect', type: 'dropdown', label: 'Workflow', required: true},
        // { name: 'chapterSelect', type: 'dropdown', label: 'Chapter', required: true },
        { name: 'draftSelect', type: 'multiselect', textfield: 'draftName', label: 'Draft',
          required: true,},
      ],
    },
    {
      type: 'Hearing Notice',
      formDef: [
        { name: 'hearingDescription', type: 'textfield', label: 'Description' },
        { name: 'action', type: 'dropdown', label: 'Action', required: true },
        { name: 'hearingDate', type: 'datepicker', label: 'Hearing Date', required: true },
        { name: 'hearingAddressLine1', type: 'textfield', label: 'Address 1', required: true },
        { name: 'hearingAddressLine2', type: 'textfield', label: 'Address 2' },
        { name: 'hearingCity', type: 'textfield', label: 'City', required: true },
        { name: 'hearingState', type: 'textfield', label: 'State', value: 'NE', required: true },
        { name: 'hearingPostalCode', type: 'textfield', label: 'Zip', required: true },
        { name: 'agencyHearingContactName', type: 'textfield', label: 'Agency Hearing Contact Name', required: true },
        { name: 'agencyHearingContactEmail', type: 'textfield', label: 'Agency Hearing Contact Email', required: true },
        { name: 'agencyHearingContactPhone', type: 'textfield', label: 'Agency Hearing Contact Phone', required: true },
        { name: 'hearingEMeetingInfo', type: 'textfield', label: 'Electronic Meeting Information', required: false },
        // {
        //   name: 'hearingNoticeUpload',
        //   type: 'fileupload',
        //   label: 'hearingNoticeUpload',
        //   required: true,
        // },
      ],
    },
    {
      type: 'Accessibility Provisions',
      formDef: [
        { name: 'accessibilityProvisionsContactPerson', type: 'textfield', label: 'Accessibility Contact Person', required: false },
        { name: 'accessibilityProvisionsPhoneNumber', type: 'textfield', label: 'Phone Number', required: false },
      ]
    },
    {
      type: 'Agency Information',
      formDef: [
        { name: 'agencyInfoName', type: 'textfield', label: 'Agency Name', required: false },
        { name: 'agencyInfoDivision', type: 'textfield', label: 'Agency Division', required: false },
        { name: 'agencyInfoAddress', type: 'textfield', label: 'Agency Address', required: false },
        { name: 'agencyInfoCity', type: 'textfield', label: 'City', required: false },
        { name: 'agencyInfoState', type: 'textfield', label: 'State', required: false },
        { name: 'agencyInfoZip', type: 'textfield', label: 'Zip Code', required: false },
        { name: 'agencyInfoPhone', type: 'textfield', label: 'Agency Phone Number', required: false },
        { name: 'agencyEmail', type: 'textfield', label: 'Agency Email', required: false }
      ]
    },
    {
      type: 'Certificate of Adoption',
      formDef: [
        { name: 'certOfAdoptSigner', type: 'textfield', label: 'Signer', required: true,},
        { name: 'certOfAdoptTitleOfSigner', type: 'textfield', label: 'Title of Signer', required: true },
        { name: 'ruleChangeType', type: 'dropdown', label: 'Type of Rule Change', required: true },
        { name: 'certOfAdoptPublicHearingHeldOn', type: 'datepicker', label: 'Public Hearing Date', required: true },
        { name: 'certOfAdoptNoticeSentOn', type: 'datepicker', label: 'Notice Sent to Secretary of State and Executive Board On', required: true }
      ],
    },
    {
      type: 'Explanatory Statement',
      formDef: [
        // { name: 'preparedBy', type: 'textfield', label: 'Prepared By' },
        { name: 'explanatoryDate', type: 'datepicker', label: 'Date Prepared', required: true },
        { name: 'reasonForAdoptionAmendmentRepeal', type: 'textarea', rows: 10, label: 'Reason for Adoption, Amendment, or Repeal', required: true,},
        { name: 'descriptionAndSummaryOfRuleChanges', type: 'textarea', rows: 10, label: 'Description of Purpose and Summary of Changes Made', required: true,},
        { name: 'changesBetweenNoticeAndHearing', type: 'textarea', rows: 10, label: 'Changes in Text between Notice and Hearing',},
        { name: 'fteImpact', type: 'textfield', label: 'FTE Impact' },
        { name: 'unfundedMandate', type: 'checkbox', label: 'Check Box if Unfunded Mandate' },
        { name: 'issuesOfUniqueInterest', type: 'textarea', label: 'Issues of Unique Interest, if applicable',},
      ],
    },
    {
      type: 'Fiscal Impact Statement',
      formDef: [
        // { name: 'preparerInfo', type: 'textfield', label: 'FTE Impact' },
        // { name: 'fteImpact', type: 'textfield', label: 'FTE Impact' },
        { name: 'fiscalDate', type: 'datepicker', label: 'Date Prepared' },
        {
          name: 'State Agency',
          type: 'region',
          label: 'State Agency',
          required: true,
          children: [
            { name: 'stateAgencyHasNoFiscalImpact', type: 'checkbox', label: 'No Fiscal Impact' },
            { name: 'stateAgencyHasIncreasedCost', type: 'checkbox', label: 'Increased Costs' },
            { name: 'stateAgencyHasDecreasedCost', type: 'checkbox', label: 'Decreased Costs' },
            { name: 'stateAgencyHasIncreasedRevenue', type: 'checkbox', label: 'Increased Revenue',},
            { name: 'stateAgencyHasDecreasedRevenue', type: 'checkbox', label: 'Decreased Revenue',},
            { name: 'stateAgencyIsIndeterminable', type: 'checkbox', label: 'Indeterminable' },
          ],
        },
        {
          name: 'Political Subdivision',
          type: 'region',
          label: 'Political Subdivision',
          required: true,
          children: [
            { name: 'politicalSubdivisionHasNoFiscalImpact', type: 'checkbox', label: 'No Fiscal Impact',},
            { name: 'politicalSubdivisionHasIncreasedCost', type: 'checkbox', label: 'Increased Costs',},
            { name: 'politicalSubdivisionHasDecreasedCost', type: 'checkbox', label: 'Decreased Costs',},
            { name: 'politicalSubdivisionHasIncreasedRevenue', type: 'checkbox', label: 'Increased Revenue',},
            { name: 'politicalSubdivisionHasDecreasedRevenue', type: 'checkbox', label: 'Decreased Revenue',},
            { name: 'politicalSubdivisionIsIndeterminable', type: 'checkbox', label: 'Indeterminable',},
          ],
        },
        {
          name: 'Regulated Public',
          type: 'region',
          label: 'Regulated Public',
          required: true,
          children: [
            { name: 'regulatedPublicHasNoFiscalImpact', type: 'checkbox', label: 'No Fiscal Impact',},
            { name: 'regulatedPublicHasIncreasedCost', type: 'checkbox', label: 'Increased Costs'},
            { name: 'regulatedPublicHasDecreasedCost', type: 'checkbox', label: 'Decreased Costs'},
            { name: 'regulatedPublicHasIncreasedRevenue', type: 'checkbox', label: 'Increased Revenue',},
            { name: 'regulatedPublicHasDecreasedRevenue', type: 'checkbox', label: 'Decreased Revenue',},
            { name: 'regulatedPublicIsIndeterminable', type: 'checkbox', label: 'Indeterminable'},
          ],
        },
        {
          name: 'indeterminableImpactDesc',
          type: 'textarea',
          rows: 10,
          label: 'If indeterminable, explain why',
        },
        {
          name: 'Description of Impact',
          type: 'region',
          label: 'Description of Impact',
          required: true,
          children: [
            { name: 'stateAgencyImpactDesc', type: 'textarea', rows: 10, label: 'State Agency' },
            { name: 'politicalSubdivisionImpactDesc', type: 'textarea', rows: 10, label: 'Political Subdivision',},
            { name: 'regulatedPublicImpactDesc', type: 'textarea', rows: 10, label: 'Regulated Public',},
          ],
        },
      ],
    },
    {
      type: 'Affidavit of Publication',
      formDef: [
        { name: 'affidavitDate', type: 'datepicker', label: 'Publication Date', required: true },
        {
          name: 'affidavitPrompt',
          type: 'message',
          message: 'Upload the Affidavit of Publication PDF on the Files tab, under the Affidavit of Publication section.',
          required: false,
          disabled: true}
      ],
    },
    {
      type: 'Hearing Summary',
      formDef: [
        { name: 'hearingDate', type: 'datepicker', label: 'Hearing Date', required: true },
        { name: 'nameOfPersonCommenting', type: 'textarea', rows: 5, label: 'Name of person commenting' },
        {name: 'affiliationOfPersonCommenting', type: 'textarea', rows: 10, label: 'Affiliation of  person commenting',},
        { name: 'hearingComments', type: 'textarea', rows: 10, label: 'Comments' },
        { name: 'agencyResponse', type: 'textarea', rows: 10, label: 'Agency Response' },
        // {
        //   name: 'hearingSummaryUpload',
        //   type: 'fileupload',
        //   rows: 10,
        //   label: 'Hearing Summary Upload',
        // },
      ],
    },
  ];
  // #endregion

  const [menuItems, setMenuItems] = useState<any>(filingMenuItems[0].menuItems);
  const [filingFormDef, setFilingFormDef] = useState<any>(filingFormDefinitions[0].formDef);

  const getFilingTabsByType = (type: string) => {
    filingMenuItems.forEach((item: any) => {
      if (item.type === type) {
        setMenuItems(item.menuItems);
      }
    });
  };

  const getFilingFormDef = (type: string) => {
    filingFormDefinitions.forEach((item: any) => {
      if (item.type === type) {
        setFilingFormDef(item.formDef);
      }
    });
  };

  return {
    // functions
    getFilingTabsByType,
    getFilingFormDef,
    // variables
    menuItems,
    filingFormDef,
  };
};

export default useFilingFormDefinitions;
